module.exports = __webpack_public_path__ + "static/btclassic-windows-screen@2x-a2ef085a4e104a8fb066e1a173e16f73.jpg";